import React from "react";

import { Input } from "../../../global";
import { WebgeoRessourcesLabels } from "../../../../config/shared/AccessManagerConfig";

interface ISearchAnyInputs {
    input: string;
}

export const SearchAnyInputs: React.FC<ISearchAnyInputs> = ({ input }) => {
    const inputConfig = WebgeoRessourcesLabels[input];

    if (!inputConfig) return null;

    return (
        <div className="flex flex-col" key={input}>
            <Input name={input} label={inputConfig} />
        </div>
    );
};
